"use strict";
var base_1 = require("@bhtp-client-api/base");
var AddressViewModel = (function () {
    function AddressViewModel() {
        this.address1 = null;
        this.address2 = null;
        this.city = null;
        this.stateOrProvince = null;
        this.postalCode = null;
    }
    AddressViewModel.fromApiAddress = function (source) {
        var target = new AddressViewModel();
        if (source) {
            target.address1 = source.address1;
            target.address2 = source.address2;
            target.city = source.city;
            target.stateOrProvince = source.stateOrProvince;
            target.postalCode = source.postalCode;
        }
        return target;
    };
    AddressViewModel.toApiAddress = function (source) {
        var target = new base_1.ApiAddress();
        if (source) {
            target.address1 = source.address1;
            target.address2 = source.address2;
            target.city = source.city;
            target.stateOrProvince = source.stateOrProvince;
            target.postalCode = source.postalCode;
        }
        return target;
    };
    return AddressViewModel;
}());
exports.AddressViewModel = AddressViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/address-view.model.js